import SubmissionsList from './SubmissionsList';
import SubmissionsDetail from "./SubmissionsDetail";

export default {
  list: SubmissionsList,
  edit: SubmissionsDetail,
}
